// extracted by mini-css-extract-plugin
module.exports = {"title":"CookieConsentTitle_title__kYkNA"};